"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @deprecated Loader component is deprecated. Use Spinner component instead.
 */
var Loader = function Loader(props) {
  if (_utils.IS_DEV) {
    console.warn("The Loader component has been renamed to Spinner and will be removed in a future release. https://canonical.github.io/react-components/?path=/story/spinner--default-story");
  }

  return /*#__PURE__*/_react.default.createElement(_Spinner.default, props);
};

var _default = Loader;
exports.default = _default;